import { render } from "./DirectPurchases.vue?vue&type=template&id=5b118e8e&scoped=true"
import script from "./DirectPurchases.vue?vue&type=script&lang=js"
export * from "./DirectPurchases.vue?vue&type=script&lang=js"

import "./DirectPurchases.vue?vue&type=style&index=0&id=5b118e8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b118e8e"]])

export default __exports__